(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glass-frames"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noc-glass')) {
    customElements.define('noc-glass', class extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.slots = Array.from(this.querySelectorAll('[data-gf]')).map((el, i) => ({
          el, i, W: 0, H: 0,
          tilt: el.querySelector('[data-tilt]'), depth: el.querySelector('[data-depth]'), ghost: el.querySelector('[data-ghost]'),
          x: .5, y: .5, tx: .5, ty: .5, hv: 0, inn: false, gin: false, gA: 0, gx: 0, gy: 0, t0: 0
        }));
        if (!this.slots.length) return;
        this.onMove = (e) => {
          for (const s of this.slots) {
            const r = s.el.getBoundingClientRect();
            const nx = (e.clientX - r.left) / r.width, ny = (e.clientY - r.top) / r.height;
            s.W = r.width; s.H = r.height;
            if (nx >= 0 && nx <= 1 && ny >= 0 && ny <= 1) {
              if (!s.inn) { s.inn = true; s.t0 = performance.now(); s.x = nx; s.y = ny; }
              s.tx = nx; s.ty = ny;
            } else s.inn = false;
          }
        };
        this.onLeave = () => { for (const s of this.slots) s.inn = false; };
        this.onUp = (e) => { if (e.pointerType === 'touch') this.onLeave(); };
        /* run only while it can be seen: inside a dialog, while it's open */
        this.dialog = this.closest('dialog');
        this.sync = () => { if (!this.dialog || this.dialog.open) this.start(); else this.stop(); };
        if (this.dialog) {
          this.mo = new MutationObserver(this.sync);
          this.mo.observe(this.dialog, { attributes: true, attributeFilter: ['open'] });
        }
        this.sync();
      }
      disconnectedCallback() {
        this.stop();
        if (this.mo) this.mo.disconnect();
      }
      start() {
        if (this.running) return;
        this.running = true;
        window.addEventListener('pointermove', this.onMove, { passive: true });
        window.addEventListener('pointerup', this.onUp);
        window.addEventListener('blur', this.onLeave);
        document.documentElement.addEventListener('mouseleave', this.onLeave);
        this.raf = requestAnimationFrame(this.tick);
      }
      stop() {
        if (!this.running) return;
        this.running = false;
        cancelAnimationFrame(this.raf);
        window.removeEventListener('pointermove', this.onMove);
        window.removeEventListener('pointerup', this.onUp);
        window.removeEventListener('blur', this.onLeave);
        document.documentElement.removeEventListener('mouseleave', this.onLeave);
        this.onLeave();
      }
      tick = (now) => {
        if (!this.running) return;
        this.raf = requestAnimationFrame(this.tick);
        const gs = .6, depth = .32, t = now / 1000, idle = !this.reduce;
        for (const s of this.slots) {
          const W = s.W || s.el.offsetWidth, H = s.H || s.el.offsetHeight;
          s.x += (s.tx - s.x) * .16; s.y += (s.ty - s.y) * .16;
          s.hv += ((s.inn ? 1 : 0) - s.hv) * .1;
          const drift = idle ? .5 + .5 * Math.sin(t * .4 + s.i * 2.1) : .5;
          const bp = drift * (1 - s.hv) + s.x * s.hv;
          let sw = -30;
          if (s.t0) { const q = (now - s.t0) / 1100; if (q >= 1) s.t0 = 0; else sw = Math.pow(1 - q, 3) * 100; }
          const st = s.el.style;
          st.setProperty('--gs', gs);
          st.setProperty('--hv', s.hv.toFixed(3));
          st.setProperty('--bp', (bp * 100).toFixed(1) + '%');
          st.setProperty('--sw', sw.toFixed(1) + '%');
          st.setProperty('--mx', (((s.x - .07) / .86) * 100).toFixed(1) + '%');
          st.setProperty('--my', (((s.y - .0531) / .8938) * 100).toFixed(1) + '%');
          st.setProperty('--sh', s.hv.toFixed(3));
          st.setProperty('--shx', (-(s.x - .5) * 12 * s.hv).toFixed(2));
          const k = this.reduce ? 0 : s.hv;
          const ry = (s.x - .5) * 12 * k, rx = -(s.y - .5) * 12 * k;
          s.tilt.style.transform = 'perspective(1000px) translate3d(0,' + (-5 * k).toFixed(2) + 'px,0) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(' + (1 + .015 * k).toFixed(4) + ')';
          s.depth.style.transform = 'translate(' + (-(s.x - .5) * 7 * k).toFixed(2) + 'px,' + (-(s.y - .5) * 7 * k).toFixed(2) + 'px)';
          const gw = .86 * W, gh = .8938 * H, px = s.x * W - .07 * W, py = s.y * H - .0531 * H;
          const ing = s.inn && px >= 0 && px <= gw && py >= 0 && py <= gh;
          const tx = px + (gw / 2 - px) * depth, ty = py + (gh / 2 - py) * depth;
          if (ing && !s.gin) { s.gx = tx; s.gy = ty; }
          s.gin = ing;
          s.gx += (tx - s.gx) * .3; s.gy += (ty - s.gy) * .3;
          s.gA += ((ing ? 1 : 0) - s.gA) * .16;
          s.ghost.style.transform = 'translate3d(' + s.gx.toFixed(1) + 'px,' + s.gy.toFixed(1) + 'px,0)';
          s.ghost.style.opacity = (s.gA * .95).toFixed(3);
        }
      };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nocCardVideo) return;
    window.__nocCardVideo = true;
    if (!window.matchMedia('(hover: hover)').matches) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.addEventListener('pointerover', function (e) {
      const card = e.target.closest && e.target.closest('[data-card-video]');
      if (!card || reduce || card.contains(e.relatedTarget)) return;
      const v = card.querySelector('video');
      if (v) { v.muted = true; v.play().catch(function () {}); }
    });
    document.addEventListener('pointerout', function (e) {
      const card = e.target.closest && e.target.closest('[data-card-video]');
      if (!card || card.contains(e.relatedTarget)) return;
      const v = card.querySelector('video');
      if (v) v.pause();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sort-pills"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noc-prints')) {
    customElements.define('noc-prints', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const pill = e.target.closest && e.target.closest('[data-sort]');
          if (!pill || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
          e.preventDefault();
          if (pill.getAttribute('aria-current') === 'true' || this.busy) return;
          this.sort(pill);
        });
      }
      sort(pill) {
        const value = pill.dataset.sort;
        const grid = this.querySelector('[data-prints-grid]');
        if (!grid) { location.href = pill.href; return; }
        this.busy = true;
        grid.setAttribute('aria-busy', 'true');
        this.querySelectorAll('[data-sort]').forEach((p) => {
          if (p === pill) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
        });
        const url = new URL(this.dataset.url || location.pathname, location.origin);
        url.searchParams.set('sort_by', value);
        url.searchParams.set('section_id', this.dataset.section);
        fetch(url.pathname + url.search)
          .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-prints-grid]');
            if (!fresh) throw new Error('no grid');
            this.swap(grid, fresh);
            const pag = this.querySelector('[data-prints-pagination]');
            const freshPag = doc.querySelector('[data-prints-pagination]');
            if (pag) pag.replaceWith(freshPag || document.createElement('span'));
            if (this.hasAttribute('data-sync-url')) {
              const here = new URL(location.href);
              here.searchParams.set('sort_by', value);
              here.searchParams.delete('page');
              history.replaceState(history.state, '', here);
            }
          })
          .catch(() => { location.href = pill.href; })
          .finally(() => { this.busy = false; grid.removeAttribute('aria-busy'); });
      }
      swap(grid, fresh) {
        const limit = parseInt(this.dataset.limit || '0', 10);
        const first = new Map();
        grid.querySelectorAll('[data-flip-id]').forEach((el) => first.set(el.dataset.flipId, el.getBoundingClientRect()));
        const items = Array.from(fresh.children).slice(0, limit > 0 ? limit : undefined);
        items.forEach((el) => el.classList.add('is-in'));
        grid.replaceChildren(...items.map((el) => document.adoptNode(el)));
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        items.forEach((el) => {
          const was = first.get(el.dataset.flipId);
          if (was) {
            const now = el.getBoundingClientRect();
            const dx = was.left - now.left;
            const dy = was.top - now.top;
            if (dx || dy) el.animate([{ translate: dx + 'px ' + dy + 'px' }, { translate: '0 0' }], { duration: 650, easing: 'cubic-bezier(.2,.8,.2,1)' });
          } else {
            el.animate([{ opacity: 0, translate: '0 24px' }, { opacity: 1, translate: '0 0' }], { duration: 600, easing: 'cubic-bezier(.2,.8,.2,1)' });
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
